module.exports = __webpack_public_path__ + "static/media/gesundheit.05997afb.jpg";